export default __webpack_public_path__ + "static/heroBackground-d958449d861c5d620c76f78d5a0d300a.png";